<template>
  <div class="special">
    <div class="special-content">
      <div class="card-table">
        <div class="table-header">
          <el-tabs class="intabs" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane name="first">
              <span slot="label"
                >最新
                <!-- <img
                  :src="
                    require('@/assets/icon/down-arrow' +
                      (currentIndex == 0 ? '1.png' : '2.png'))
                  "
                  alt=""
              /> -->
              </span>
              <speciallist-box
                v-loading="loading"
                :data-list="cardList"
              ></speciallist-box>
              <noData v-if="total == 0"></noData>
              <div class="pagination-box" v-show="total > 0">
                <el-pagination
                  class="ou-pagination"
                  background
                  hide-on-single-page
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-sizes="[20, 40, 60, 80, 100]"
                  :page-size="queryParams.pageSize"
                  layout="total, prev, pager, next, sizes, jumper, slot"
                  :total="total"
                >
                  <el-button @click="getList()" class="ou-page-go"
                    >GO</el-button
                  >
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane name="second">
              <span slot="label"
                >价格
                <!-- <img
                  :src="
                    require('@/assets/icon/down-arrow' +
                      (currentIndex == 1 ? '1.png' : '2.png'))
                  "
                  alt=""
              /> -->
              </span>
              <speciallist-box
                v-loading="loading"
                :data-list="cardList"
              ></speciallist-box>
              <noData v-if="total == 0"></noData>
              <div class="pagination-box" v-show="total > 0">
                <el-pagination
                  class="ou-pagination"
                  background
                  hide-on-single-page
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-sizes="[20, 40, 60, 80, 100]"
                  :page-size="queryParams.pageSize"
                  layout="total, prev, pager, next, sizes, jumper, slot"
                  :total="total"
                >
                  <el-button @click="getList()" class="ou-page-go"
                    >GO</el-button
                  >
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane name="third">
              <span slot="label"
                >销量
                <!-- <img
                  :src="
                    require('@/assets/icon/down-arrow' +
                      (currentIndex == 2 ? '1.png' : '2.png'))
                  "
                  alt=""
              /> -->
              </span>
              <speciallist-box
                v-loading="loading"
                :data-list="cardList"
              ></speciallist-box>
              <noData v-if="total == 0"></noData>
              <div class="pagination-box" v-show="total > 0">
                <el-pagination
                  class="ou-pagination"
                  background
                  hide-on-single-page
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-sizes="[20, 40, 60, 80, 100]"
                  :page-size="queryParams.pageSize"
                  layout="total, prev, pager, next, sizes, jumper, slot"
                  :total="total"
                >
                  <el-button @click="getList()" class="ou-page-go"
                    >GO</el-button
                  >
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div class="search">
            <input
              type="text"
              class="custom-input"
              v-model.trim="subjectName"
              @keyup.enter="handleQuery"
              placeholder="请输入"
            />
            <el-button
              type="primary"
              class="custom-button"
              @click="handleQuery"
              icon="el-icon-search"
              >搜索</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ListSpecial } from "@/api/special/special";
import speciallistBox from "@/components/speciallistBox";
import noData from "@/components/noData.vue";
export default {
  data() {
    return {
      loading: true,
      subjectName: null,
      activeName: "first",
      total: 0,
      total2: 0,
      total3: 0,
      cardList: [],
      currentIndex: 0,
      // 最新——查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        subjectName: null,
        orderName: "create_time",
        orderType: "desc",
      },
    };
  },
  components: { speciallistBox, noData },
  created() {
    this.getList();
  },
  watch: {
    //监听
    $route(to, from) {
      //路由变化方式，当路由跳转到专题列表时，方法就会执行
     if(to.path == '/special/index'){
       this.getList();
     }
    },
  },
  methods: {
    async getList() {
      //获取最新专题列表
      // this.queryParams.orderName = "create_time";
      await ListSpecial(this.queryParams).then((res) => {
        this.loading = false;
        this.cardList = res.rows;
        this.total = res.total;

      });
    },
    // 搜索按钮操作
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.queryParams.subjectName = this.subjectName;
      this.getList();
    },
    handleClick(tab) {
      this.currentIndex = tab.index;
      if (tab.index == 1) {
        this.queryParams.orderName = "selling_price";
        this.getList();
      } else if (tab.index == 2) {
        this.queryParams.orderName = "sales_volume";
        this.getList();
      } else if (tab.index == 0) {
        this.queryParams.orderName = "create_time";
        this.getList();
      }
    },
    //每页条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    //当前页面
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang='scss'>
.special {
  .special-content {
    // height: 100%;
    min-height: calc(100vh - 310px);
    padding-bottom: 40px;
    // background: #FBFBFB;
    .card-table {
      width: 1400px;
      height: auto;
      // min-height: calc(100vh - 364px);
      background: #fffefd;
      margin: 0 auto;
      padding: 0 30px;
      box-sizing: border-box;
      .table-header {
        position: relative;
        ::v-deep .el-tabs {
          padding-top: 10px;
          .el-tabs__item {
            span {
              display: flex;
              align-items: center;
              font-size: 16px;
              img {
                width: 14px;
                height: 14px;
                margin-left: 2px;
              }
            }
          }
          //  .el-tabs__nav-wrap::after{
          //   height: 1px;
          // }
          // .el-tabs__active-bar {
          //   height: 3px;
          // }
        }
        .search {
          height: 32px;
          position: absolute;
          right: 0;
          top: 9px;
        }
      }
    }
    .pagination-box {
      text-align: right;
      padding-bottom: 30px;
    }
  }
}
</style>
